// One date format for the whole DI tab (target-state design, review D25).
// Before: "Jul 27" in the drawer, "Jul 27, 2026, 3:41 PM" in headers, and a
// raw toLocaleString() WITH SECONDS on action cards — three dialects.
// Rules: no seconds; year only when it differs from the current year.

/**
 * @param {string|number|Date} value - anything Date.parse / new Date() accepts
 * @param {Object} [options]
 * @param {boolean} [options.includeTime=true] - append "3:41 PM"
 * @returns {?string} formatted date, or null for missing/invalid input
 */
export const formatDateTime = (value, { includeTime = true } = {}) => {
    if (!value) return null
    const date = value instanceof Date ? value : new Date(value)
    if (Number.isNaN(date.getTime())) return null

    const sameYear = date.getFullYear() === new Date().getFullYear()
    const options = {
        month: 'short',
        day: 'numeric',
        ...(sameYear ? {} : { year: 'numeric' }),
        ...(includeTime ? { hour: 'numeric', minute: '2-digit' } : {}),
    }
    return date.toLocaleString('en-US', options)
}

/** Date-only convenience ("Jul 27" / "Jul 27, 2025"). */
export const formatDate = (value) => formatDateTime(value, { includeTime: false })
